module.exports = __webpack_public_path__ + "static/media/microsoft.564db913.svg";